jQuery(document).ready(function ($) {
    const sections = $(".flexible-section--two-cols");

    sections.find(".two-cols__video").on("click", function (event) {
        event.stopPropagation();

        const currentSection = $(this).closest(".flexible-section--two-cols");
        const videoPopup = currentSection.find(".two-cols__video-popup");

        videoPopup.addClass("two-cols__video-popup--active");

        $(document).one("click.videoPopup", function (event) {
            if (!$(event.target).closest(".two-cols__video-content").length) {
                videoPopup.removeClass("two-cols__video-popup--active");
                currentSection.find("iframe").each(function () {
                    const src= $(this).attr('src');
                    $(this).attr('src',src);
                });
            }
        });
    });
});
